import { Card } from "components/Card/Card.jsx";
import React, { useEffect, useState } from "react";
import { Col, Grid, Row } from "react-bootstrap";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { alertActions } from "../../../redux/actions/alert-actions";
import { getOrder } from "../../../redux/actions/order-actions";
import { settingsService } from "../../../services/settings";
import ChatWrapper from "./ChatWrapper";
var Modal = require('react-bootstrap-modal');

function AdminChat(props) {
    
    const [targetedMessageAllModal, setTargetedMessageAllModal] = useState(false);
    const [targetedMessage, setTargetedMessage] = useState('');
    useEffect(() => {
        console.log(props.match.params.order_id, "Order id");
        
        props.getOrderCall(props.match.params.order_id);
        getTargetedMessageAllSettings();
    }, []);
    
    function openTargetedMessageAllModal() {
        setTargetedMessageAllModal(!targetedMessageAllModal)
    }
    function getTargetedMessageAllSettings() {
        settingsService.getTargetedMessageAllSettings({order_id: props.match.params.order_id}).then(response => {
            var settings = response && response.targetedMessageAllSettings
                ? response.targetedMessageAllSettings
                : {};
            const defaultMessage = settings && settings.targeted_message_all_default ? settings.targeted_message_all_default.value : '';
            setTargetedMessage(defaultMessage != null ? defaultMessage : '')
        });
    };
    function messageSubmitHandler() {
        const data = {
            message: targetedMessage,
            order_id: props.match.params.order_id
        }
        settingsService.sendCustomTargetedMessageAll(data).then(response => {
            console.log("response", response);
            if(response.status === "success") {
                props.success(response.message);
                setTargetedMessageAllModal(false)
            }
            
        })
    }
    if (!props.order_details || !props.order_details.barcode) {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card content={<p>Loading...</p>} />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }

    const returnDate = props.order_details.order_dates && props.order_details.order_dates.return_date
        ? props.order_details.order_dates.return_date.value
        : undefined;

    function shouldShowMessage () {
        /* //TODO: Hiding for now will enable later Targeted Message All */
        return false;

        if (!returnDate) return false;

        const returnDateObj = new Date(returnDate);
        const lastAllowedDate = new Date(returnDateObj);
        lastAllowedDate.setDate(lastAllowedDate.getDate() + 3);
        
        const today = new Date();

        return today <= lastAllowedDate;
    };
        
    const chatSetting = props.order_details.settings && props.order_details.settings.is_allow_one_to_one_chat;

    const isAllowOneToOneChat = chatSetting ? Number(chatSetting.value) : 0;

    return (
        <div className="content">
            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            content={
                                <React.Fragment>
                                    <h4><strong>Order Number: {props.order_details.barcode}</strong></h4>
                                    {
                                        shouldShowMessage() && (
                                            <div style={{ float: "" }}>
                                                <a
                                                    href="#"
                                                    className="blue_link"
                                                    style={{ fontWeight: 'bold', cursor: 'pointer' }}
                                                    onClick={function (e) {
                                                        e.preventDefault();
                                                        openTargetedMessageAllModal();
                                                    }}
                                                >
                                                    Custom Targeted Message All
                                                </a>
                                            </div>
                                        )
                                    }
                                    <ChatWrapper is_allow_one_to_one_chat={isAllowOneToOneChat}/>
                                </React.Fragment>

                            }
                        />
                    </Col>
                </Row>
            </Grid>

            <Modal size="sm" backdrop={'static'} show={targetedMessageAllModal} id="" onHide={function () {
        setTargetedMessageAllModal(false);
    }} aria-labelledby="ModalHeader" className="" >
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader' className="headerTitle">Custom Targeted Message All</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="clearfix">
                        <textarea style={{ "minHeight": "100px" }} type="text" value={targetedMessage} onChange={(e) => setTargetedMessage(e.target.value)} className="form-control" placeholder="Enter Custom Targeted Message All"/>
                        <br />
                        {/* <button onClick={closeModal.bind(this, "targetedMessageAllModal")}  className="folderBtn mr-md "> Back</button> */}

                        <div className="section-frontEnd">
                            <button onClick={() => messageSubmitHandler()} style={{float: "right"}} className="pl-xlg pr-xlg themeBtn_12 blue_theme_button hover_dark">Submit</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

const mapStateToProps = (state) => {
    const { order_details } = state.ordersReducer;
    return {
        order_details
    }
}

const mapDispatchToProps = dispatch => {
    return {
		getOrderCall: (orderId) => { dispatch(getOrder(orderId)) },
        success: (message) => { return dispatch(alertActions.success(message)) },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminChat));
